export interface DocumentationButtonProps {
  document?: string;

  //  Use for help button not in the page header
  fullPath?: string;
}

export type DocumentKey = keyof typeof DocumentPath;

export enum DocumentPath {
  ACCOUNT_SETTINGS_CENTRAL_AUTHENTICATION = 'km_accountsettings_central_auth',
  ACCOUNT_SETTINGS_CHANGE_ORG = 'km_accountsettings_changeorg',
  ACCOUNT_SETTINGS_GAMEPAD_HOTKEYS = 'km_accountsettings_gamepad_hotkeys',
  ACCOUNT_SETTINGS_GENERAL = 'km_accountsettings_general',
  ACCOUNT_SETTINGS_LOGOUT = 'km_accountsettings_logout',
  ACCOUNT_SETTINGS_MAP = 'km_accountsettings_map',
  ACCOUNT_SETTINGS_MY_PROFILE = 'km_accountsettings_myprofile',
  ACCOUNT_SETTINGS_NOTIFICATIONS = 'km_accountsettings_notification',
  ACCOUNT_SETTINGS_RESET_PREFERENCES = 'km_accountsettings_resetpreferences',
  ASSET_MANAGEMENT_INVENTORY = 'km_mod_asset_mgmt_inv',
  ASSET_MANAGEMENT_INVENTORY_ADD = 'km_mod_asset_mgmt_inv_add_asset',
  ASSET_MANAGEMENT_INVENTORY_IMPORT = 'km_mod_asset_mgmt_inv_import_asset',
  ASSET_MANAGEMENT_INVENTORY_EDIT = 'km_mod_asset_mgmt_inv_edit_asset',
  ASSET_MANAGEMENT_INVENTORY_DETAILS = 'km_mod_asset_mgmt_inv_view_asset_details',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_OVERVIEW = 'km_mod_asset_mgmt_inv_view_asset_overview_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_STOCK = 'km_mod_asset_mgmt_inv_view_asset_stock_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_CHILDREN = 'km_mod_asset_mgmt_inv_view_asset_chld_assets_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_WORK_ORDERS = 'km_mod_asset_mgmt_inv_view_asset_workorders_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_TRANSACTIONS = 'km_mod_asset_mgmt_inv_view_asset_transactions_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_ACTIVITY_LOG = 'km_mod_asset_mgmt_inv_view_asset_activitylog_tab',
  ASSET_MANAGEMENT_INVENTORY_DETAILS_DOCUMENTS = 'km_mod_asset_mgmt_inv_view_asset_doc_tab',
  ASSET_MANAGEMENT_INVENTORY_DOWNLOAD_TEMPLATE = 'km_mod_asset_mgmt_inv_download_template',
  ASSET_MANAGEMENT_WORK_ORDERS_MANAGE = 'km_mod_asset_mgmt_workorders_manage',
  ASSET_MANAGEMENT_WORK_ORDERS_ADD = 'km_mod_asset_mgmt_workorders_add',
  ASSET_MANAGEMENT_WORK_ORDERS_DETAILS = 'km_mod_asset_mgmt_workorders_details_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_WORK_ORDER = 'km_mod_asset_mgmt_workorders_work_order_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_COMMENTS = 'km_mod_asset_mgmt_workorders_comments_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_TIME_TRACKER = 'km_mod_asset_mgmt_workorders_time_tracker_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_DOCUMENTS = 'km_mod_asset_mgmt_workorders_Documents_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_SUB_WORKORDER = 'km_mod_asset_mgmt_workorders_sub_workorder_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_LINKS = 'km_mod_asset_mgmt_workorders_links_tab',
  ASSET_MANAGEMENT_WORK_ORDERS_ACTIVITYLOG = 'km_mod_asset_mgmt_workorders_activitylog_tab',

  ASSET_MANAGEMENT_WORK_ORDER_CONFIGS = 'km_mod_asset_mgmt_workorder_configs',
  ASSET_MANAGEMENT_WORK_ORDER_CONFIGS_ADD = 'km_mod_asset_mgmt_workorder_configs_add',
  ASSET_MANAGEMENT_WORK_ORDER_CONFIGS_EDIT = 'km_mod_asset_mgmt_workorder_configs_edit',

  ASSET_MANAGEMENT_WORK_ORDER_CONFIGS_DELETE = 'km_mod_asset_mgmt_workorder_configs_delete',
  ASSET_MANAGEMENT_WORK_ORDER_CONFIGS_CLONE = 'km_mod_asset_mgmt_workorder_configs_clone',

  ACCOUNT_SETTINGS_THEMES = 'km_accountsettings_theme',
  COMMUNICATION_LOGS = 'km_communication_logs',
  CONTACT_GROUPS = 'km_system_settings_contact_groups',
  CONTACTS = 'km_system_settings_contacts_1',
  CONTACTS_CREATE = 'km_system_settings_contacts_create',
  CONTACTS_DELETE = 'km_system_settings_contacts_delete',
  CONTACTS_EDIT = 'km_system_settings_contacts_edit',
  CONTACTS_ORGANIZATIONS = 'km_system_settings_contacts_organizations',
  CORRIDORS = 'km_mod_corridors_overview',
  CORRIDORS_CREATE = 'km_mod_corridors_create',
  CORRIDORS_DELETE = 'km_mod_corridors_delete',
  CORRIDORS_DETAILS = 'km_mod_corridors_edit_details_tab',
  CORRIDORS_DETAILS_DOCUMENTS = '',
  CORRIDORS_EDIT = 'km_mod_corridors_create',
  CORRIDORS_EDIT_PLANS = 'km_mod_corridors_edit_plans_tab',
  CORRIDORS_INTEGRATIONS = 'km_mod_corridors_edit_devices_tab',
  CORRIDORS_MANAGE = 'km_mod_corridors_manage',
  CORRIDORS_RULES = 'km_mod_corridors_edit_rules_tab',
  CORRIDORS_SCHEMATICS = 'km_mod_corridors_edit_schematics_tab',
  CORRIDORS_SCHEMATICS_CAMERAS = 'km_mod_corridors_schematics_tab_cameras',
  CORRIDORS_SCHEMATICS_CUTOUTS = 'km_mod_corridors_schematics_tab_cutouts',
  CORRIDORS_SCHEMATICS_LANDMARKS = 'km_mod_corridors_schematics_tab_landmarks',
  CORRIDORS_SCHEMATICS_LANES = 'km_mod_corridors_schematics_tab_lanes',
  CORRIDORS_SCHEMATICS_SETTINGS = 'km_mod_corridors_schematics_tab_settings',
  CORRIDORS_SCHEMATICS_SIGNS = 'km_mod_corridors_schematics_tab_signs',
  CORRIDORS_SCHEMATICS_ZONES = 'km_mod_corridors_schematics_tab_zones',
  CORRIDORS_VIEW = 'km_mod_corridors_view',
  CORRIDORS_VIEW_ACTIVITY_LOG = 'km_mod_corridors_view_activitylog',
  CORRIDORS_VIEW_CAMERAS = 'km_mod_corridors_view_cameras',
  CORRIDORS_VIEW_COUNTS = 'km_mod_corridors_view_detectors',
  CORRIDORS_VIEW_DETECTIONS = 'km_mod_corridors_view_detections',
  CORRIDORS_VIEW_EVENTS = 'km_mod_corridors_view_events',
  CORRIDORS_VIEW_SIGNS = 'km_mod_corridors_view_signs',
  CORRIDORS_VIEW_VSL = 'km_mod_corridors_view_vsl_tab',
  CORRIDORS_VIEW_LCS = 'km_mod_corridors_view_lcs_tab',
  CORRIDORS_VIEW_MAP = 'km_mod_corridors_map_tab',
  CORRIDORS_VIEW_TRAVEL_TIME = 'km_mod_corridors_travel_time',
  CORRIDORS_VIEW_WEATHER = 'km_mod_corridors_weather',
  COUNTS_ALARMS = 'km_mod_counts_alarms',
  COUNTS_PERFORMANCE_REPORTS = 'km_mod_counts_perform_reports',
  COUNTS_REPORT_CONFIGURATIONS = 'km_mod_counts_config_report_config',
  COUNTS_REPORTS = 'km_mod_counts_reports',
  COUNTS_REPORTS_CUSTOM = 'km_mod_counts_reports_custom',
  COUNTS_REPORTS_PER_VEHICLE = 'km_mod_counts_reports_PerVehRecords',
  COUNTS_REPORTS_SPEED = 'km_mod_counts_reports_speed',
  COUNTS_REPORTS_SUMMARY = 'km_mod_counts_reports_summary',
  COUNTS_REPORTS_VOLUME = 'km_mod_counts_reports_volume',
  COUNTS_REPORTS_VEHICLEGROSSWEIGHTCOUNT = 'km_mod_counts_reports_mean_gross_weight',
  COUNTS_REPORTS_MEAN_GROSS_WEIGHT = 'km_mod_counts_reports_gross_weight_band',
  COUNTS_REPORTS_VEHICLEAXLECOUNT = 'km_mod_counts_reports_no_of_axles',
  COUNTS_REPORTS_VEHICLEGROSSAXLEWEIGHTCOUNT = 'km_mod_counts_reports_axle_weight_band',
  COUNTS_RULES = 'km_mod_counts_config_rules',
  COUNTS_RULES_CREATE = 'km_mod_counts_config_rules_new',
  COUNTS_RULES_EDIT = 'km_mod_counts_config_rules_edit',
  COUNTS_SETTINGS = 'km_mod_counts_config_settings',
  COUNTS_SETTINGS_ALARMS = 'km_mod_counts_settings_alarm_configuration',
  COUNTS_SETTINGS_DENSITY = 'km_mod_counts_settings_density_threshold',
  COUNTS_SETTINGS_OCCUPANCY = 'km_mod_counts_settings_occupancy_threshold',
  COUNTS_SETTINGS_SPEED = 'km_mod_counts_settings_speed_threshold',
  COUNTS_SETTINGS_VOLUME = 'km_mod_counts_settings_volume_threshold',
  COUNTS_SETTINGS_COUNT_CLASS = 'km_mod_counts_config_settings_CountClass',
  COUNTS_SETTINGS_EMAIL_NOTIFICATIONS = 'km_mod_counts_config_settings_EmailNotify',
  COUNTS_SITE_DETAIL = 'km_mod_counts_sitedetail',
  COUNTS_SETTINGS_REPORTS = 'km_mod_counts_config_settings_report_configs',
  COUNTS_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_counts_reports_system_reports_historical_alarm_report',
  COUNTS_SYSTEM_REPORTS = '',
  COUNTS_SITE_GROUP_CREATE = 'km_mod_counts_site_groups_create',
  COUNTS_SITE_GROUP_EDIT = 'km_mod_counts_site_groups_edit',
  COUNTS_SITE_GROUPS = 'km_mod_counts_site_groups',
  COUNTS_SITES = 'km_mod_counts_Sites',
  COUNTS_ACTIVITY_LOG = 'km_mod_counts_reports_activity_log',
  CUTOUTS = 'km_mod_signs_manage_groups',
  CUTOUTS_CREATE = 'km_mod_signs_manage_groups',
  CUTOUTS_DELETE = 'km_mod_signs_manage_groups',
  CUTOUTS_EDIT = 'km_mod_signs_manage_groups',
  EMAIL_ACTIVITY_LOGS = 'km_system_settings.emailgen_actlogs',
  EMAIL_RULES = 'km_mod_events_rules_notifications',
  EMAIL_RULES_CREATE = 'km_mod_events_rules_notifications_add',
  EMAIL_RULES_EDIT = 'km_mod_events_rules_notifications_edit',
  EMAIL_TEMPLATES = 'km_system_settings.emailgen_templates',
  EVENT_DASHBOARD = 'km_mod_events_dashboard',
  EVENT_DETECTION = 'km_mod_events_EventDet',
  EVENT_MANAGEMENT = 'km_mod_events_EventMgmt',
  EVENT_MANAGEMENT_CREATE = 'km_mod_events_mgmt_create_event',
  EVENT_RESOURCE_PLANS = 'km_mod_events_resourceplans',
  EVENT_RESOURCE_PLAN_DETAILS = 'km_mod_events_resourceplans_view',
  EVENT_RESOURCE_PLAN_SCHEDULER = 'km_mod_events_resourceplans_manage_scheduler_tab',
  EVENT_RESOURCE_PLAN_SIGNS = 'km_mod_events_resourceplans_manage_signs_tab',
  EVENT_RESOURCE_PLAN_SPEED_LIMITS = 'km_mod_events_resourceplans_manage_speed_limits_tab',
  EVENT_RESOURCE_PLAN_LANE_CONTROLS = 'km_mod_events_resourceplans_manage_lane_controls_tab',
  EVENT_RESOURCE_PLAN_ACTION_SETS = 'km_mod_events_resourceplans_manage_action_sets_tab',
  EVENT_RESOURCE_PLAN_ACTIVITY_LOG = 'km_mod_events_resourceplans_manage_activity_log_tab',
  EVENT_RESOURCE_PLAN_TRAFFIC_CONTROL = 'km_mod_events_resourceplans_manage_trafficcontrtol_tab',
  EVENT_RESOURCE_PLAN_DETOURS = 'km_mod_events_resourceplans_manage_detours_tab',
  EVENT_FAILED_RESOURCE_PLAN_RESULT = '',

  EVENT_SETTINGS_SCHEDULES = 'km_mod_events_config_settings_event_schedules',
  EVENT_SETTINGS_RESPONSE = 'km_mod_events_config_settings_event_response',
  EVENT_SETTINGS_DETECTION = 'km_mod_events_config_settings_event_detection',
  EVENT_SETTINGS_ALARMS = 'km_mod_events_config_settings_alarm_configuration',

  EVENT_REVIEW = 'km_mod_events_EventReview',
  EVENT_SETTINGS = 'km_mod_events_config_settings',
  EVENT_SIGN_RULES = 'km_mod_events_signresprules',
  EVENT_TYPES = 'km_mod_events_config_eventtypes',
  EVENTS_LINK = 'km_mod_events_schedules_link',
  EVENTS_RESOURCE_PLANS_CREATE = 'km_mod_events_resourceplans_create',
  EVENTS_RULES = 'km_mod_events_rules',
  EVENTS_RULES_CLONE = 'km_mod_events_rules_clone',
  EVENTS_RULES_CREATE = 'km_mod_events_rules_create',
  EVENTS_RULES_EDIT = 'km_mod_events_rules_edit',
  EVENTS_SCHEDULES = 'km_mod_events_schedules',
  EVENTS_SCHEDULES_CREATE = 'km_mod_events_schedules_create',
  EVENTS_TEMPLATES = 'km_mod_events_config_eventtemplates',
  EVENTS_TEMPLATES_CLONE = 'km_mod_events_config_eventtemplates_clone',
  EVENTS_TEMPLATES_CREATE = 'km_mod_events_config_eventtemplates_create',
  EVENTS_TEMPLATES_EDIT = 'km_mod_events_config_eventtemplates_edit',
  EVENTS_ALARMS = 'km_mod_events_maintenance_event_alarms',
  EVENTS_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_events_reports_system_reports_historical_alarm_report',
  EVENTS_SYSTEM_REPORTS = '',
  EVENTS_ACTIVITY_LOG = 'km_mod_events_reports_activitylog',

  FILE_MANAGER = 'km_system_settings_file_mgr',
  GANTRIES = 'km_mod_signs_manage_groups',
  GANTRIES_CREATE = 'km_mod_signs_manage_groups',
  GANTRIES_DELETE = 'km_mod_signs_manage_groups',
  INTEGRATION_GROUP = 'km_mod_Integration_groups',
  INTEGRATION_GROUP_CREATE = 'km_mod_Integration_groups_creating',
  INTEGRATION_GROUP_DELETE = 'km_mod_Integration_groups_deleting',
  INTEGRATIONS = 'km_mod_Integrations_managing',
  INTEGRATIONS_CREATE = 'km_mod_Integrations_configuring_new',
  INTEGRATIONS_DELETE = 'km_mod_Integrations_deleting',
  INTEGRATIONS_EDIT = 'km_mod_Integrations_editing',
  INTEGRATIONS_VIEW_REALTIME = 'km_mod_Integrations_viewing_real_time_tab',
  INTEGRATIONS_VIEW_ACTIVITY_LOG = 'km_mod_Integrations_viewing_activity_tab',
  LANE_CONTROL_CREATE = 'km_mod_signs_config_lanectrlsettings_create',
  LANE_CONTROL_DELETE = 'km_mod_signs_config_lanectrlsettings_delete',
  LOCATIONS = 'km_mod_locations_overview',

  LOCATIONS_LIST = 'km_mod_locations_manage_locations_overview',
  LOCATIONS_DETAILS = 'km_mod_locations_view',
  LOCATIONS_DETAILS_ASSOCIATIONS = 'km_mod_locations_view_associations',
  LOCATION_ADD = 'km_mod_locations_manage_locations_add',
  LOCATION_EDIT = 'km_mod_locations_manage_locations_edit',
  LOCATION_EDIT_DETAILS = 'km_mod_locations_manage_locations_edit',
  LOCATION_DOCUMENTS = 'km_mod_locations_view_documents',
  LOCATION_LINKS = 'km_mod_locations_view_external_links',
  LOCATION_COMMENTS = 'km_mod_locations_view_comments',
  LOCATIONS_TEMPLATE = 'km_mod_locations_location_templates',
  LOCATIONS_TEMPLATE_CREATE = 'km_mod_locations_location_template_create',
  LOCATIONS_TEMPLATE_DELETE = 'km_mod_locations_location_templates_delete_template',
  LOCATIONS_DELETE = 'km_mod_locations_manage_locations_delete',
  LOCATIONS_CLONE = 'km_mod_locations_manage_locations_clone',
  LOCATIONS_TREE = 'km_mod_location_location_tree_overview',
  LOCATIONS_TREE_ADD_GROUP = 'km_mod_location_location_tree_add_group',
  LOCATIONS_TREE_MANAGE_ORDERS = 'km_mod_location_location_tree_manage_orders',
  LOCATIONS_TREE_ADD_CHILD_GROUP = 'km_mod_location_location_tree_add_child_group',
  LOCATIONS_TREE_MOVE_GROUP = 'km_mod_location_location_tree_move_group',
  LOCATIONS_TREE_DELETE_GROUP = 'km_mod_location_location_tree_remove_group',
  LOCATIONS_TREE_MOVE_LOCATION = 'km_mod_location_location_tree_move_location',

  LANE_CONTROL_EDIT = 'km_mod_signs_config_lanectrlsettings_edit',
  LANE_CONTROLS = 'km_mod_signs_config_lanectrlsettings',
  LICENSES = 'km_system_settings_licenses',
  MAP = 'km_map',
  NOTIFICATIONS = 'km_notifications_overview',
  OVERVIEW = 'km_overview',
  ROLES = 'settingsanddocs_security_roles',
  SERVICE_ACCOUNT = 'km_system_settings_serviceacount',
  SETTINGS_ABOUT = 'km_system_settings_about',
  SIGN_DETAILS = 'km_mod_signs_detail_view',
  SIGN_DETAILS_ACTIVITYLOG = 'km_mod_signs_detail_view_ActivityLogTab',
  SIGN_DETAILS_COMMAND = 'km_mod_signs_detail_view_CommandTab',
  SIGN_DETAILS_WORK_ORDERS = 'km_mod_signs_detail_view_workorderstab',
  SIGN_DETAILS_FONTS = 'km_mod_signs_detail_view_FontsTab',
  SIGN_DETAILS_GRAPHICS = 'km_mod_signs_detail_view_GraphicsTab',
  SIGN_DETAILS_MESSAGELOG = 'km_mod_signs_detail_view_MessageLogTab',
  SIGN_DETAILS_MESSAGES = 'km_mod_signs_detail_view_MessagesTab',
  SIGN_DETAILS_QUEUE = 'km_mod_signs_detail_view_QueueTab',
  SIGN_DETAILS_SETTINGS = 'km_mod_signs_detail_view_SettingsTab',
  SIGN_DETAILS_STATUSLOG = 'km_mod_signs_detail_view_StatusLogTab',
  SIGN_MESSAGE_LIBRARY = 'km_modules_signs_message_library',
  SIGN_MESSAGE_LIBRARY_CLONE = 'km_modules_signs_message_library_clone',
  SIGN_MESSAGE_LIBRARY_CREATE = 'km_mod_signs_messages_creating',
  SIGN_MESSAGE_LIBRARY_DELETE = 'km_modules_signs_message_library_delete',
  SIGN_MESSAGE_LIBRARY_EDIT = 'km_modules_signs_message_editor',
  SIGN_PRIORITIES = 'km_mod_signs_message_priorities',
  SIGN_SETTINGS = 'km_mod_signs_config_manage_signsettings',
  SIGN_SETTINGS_GENERAL = 'km_mod_signs_config_settings_general',
  SIGN_SETTINGS_ALARMS = 'km_mod_signs_config_settings_alarm_configuration',
  SIGN_SYSTEM_REPORTS = '',
  SIGN_REPORTS_HISTORICAL_ALARMS = 'km_mod_signs_reports_system_reports_historical_alarm_report',
  SIGNAL_ACTION_SETS = 'km_mod_signals_action_sets',
  SIGNAL_INTERSECTIONS = 'km_mod_signals_intersections',
  SIGNAL_INTERSECTIONS_ADD = 'km_mod_signals_manage_signals_adding',
  SIGNAL_INTERSECTIONS_ADD_ALARMS = 'km_mod_signals_manage_signals_adding_alarms',
  SIGNAL_INTERSECTIONS_ADD_CROSSWALKS = 'km_mod_signals_manage_signals_adding_ped_phases',
  SIGNAL_INTERSECTIONS_ADD_DETAILS = 'km_mod_signals_manage_signals_adding_details',
  SIGNAL_INTERSECTIONS_ADD_DETECTORS = 'km_mod_signals_manage_signals_adding_detectors',
  SIGNAL_INTERSECTIONS_ADD_LANES = 'km_mod_locations_manage_locations_adding_lanes',
  SIGNAL_INTERSECTIONS_ADD_MANEUVERS = 'km_mod_signals_manage_signals_adding_phases',
  SIGNAL_INTERSECTIONS_ADD_MAPDETAILS = 'km_mod_signals_manage_signals_adding_mapdetails',
  SIGNAL_INTERSECTIONS_ADD_MULTIMODAL = 'km_mod_signals_manage_signals_adding_multimodal',
  SIGNAL_TIMESPACE = 'km_mod_signals_timespacediag',
  SIGNAL_TRAFFIC_RESPONSIVE = 'km_mod_signals_signal_traffic_responsive',
  SIGNAL_TRAFFIC_RESPONSIVE_CREATE = 'km_mod_signals_signal_TRplan_create',
  SIGNAL_TRAFFIC_RESPONSIVE_SCHEDULE = 'km_mod_signals_signal_TRplan_schedule',
  SIGNALS_ACTIVITY_LOG = 'km_modules_signals_activitylog',
  SIGNALS_ALARMS = 'km_mod_signals_signal_alarms',
  SIGNALS_APPLIED_COMMANDS = 'km_mod_signals_applied_cmds',
  SIGNALS_DATABASE_EDITOR = 'km_signals_dbeditor__config_edit_database',
  SIGNALS_DATABASE_EDITOR_STATUS = 'km_signals_dbeditor__config_view_controller_status',
  SIGNALS_DATABASE_EXPORT_TEMPLATES = 'km_mod_signals_DatabaseExportTemplates',
  SIGNALS_DETECTOR_GROUPS = 'km_mod_signals_detector_groups',
  SIGNALS_DETECTOR_GROUPS_ADD = 'km_mod_signals_detector_groups_add',
  SIGNALS_DETECTOR_GROUPS_DELETE = 'km_mod_signals_detector_groups_delete',
  SIGNALS_DETECTOR_GROUP_DETAILS_VIEW = 'km_mod_signals_detector_groups_view',
  SIGNALS_DETECTOR_GROUP_ACTIVITY_LOG = 'km_mod_signals_detector_groups_activitylog_tab',
  SIGNALS_DETECTOR_GROUP_OVERVIEW = 'km_mod_signals_detector_groups_overview_tab',
  SIGNALS_INTERSECTION_ACTIVITY_LOG = 'km_mod_signals_manage_signals_View_ActivityLogTab',
  SIGNALS_INTERSECTION_CLONE = 'km_mod_signals_manage_signals_cloning',
  SIGNALS_INTERSECTION_DATABASES = 'km_mod_signals_manage_signals_View_DatabasesTab',
  SIGNALS_INTERSECTION_DOCUMENTS = 'km_mod_signals_manage_signals_View_DocumentsTab',
  SIGNALS_INTERSECTION_EDIT = 'km_mod_signals_manage_signals_edit',
  SIGNALS_INTERSECTION_OVERVIEW = 'km_mod_signals_manage_signals_View_OverviewTab',
  SIGNALS_INTERSECTION_REPORTS = 'km_mod_signals_manage_signals_View_ReportsTab',
  SIGNALS_INTERSECTION_SCHEDULER = 'km_mod_signals_manage_signals_View_SchedulerTab',
  SIGNALS_INTERSECTION_VIEW = 'km_mod_signals_manage_signals_View',
  SIGNALS_INTERSECTIONS = 'km_mod_signals_manage_signals',
  SIGNAL_INTERSECTION_FROM_TEMPLATE = 'km_mod_signals_manage_signals_adding_from_template',
  SIGNALS_INTERSECTIONS_TEMPLATE = 'km_mod_signals_intersection_templates',
  SIGNALS_INTERSECTIONS_TEMPLATE_CREATE = 'km_mod_signals_manage_signals_createtemplate',
  SIGNALS_INTERSECTIONS_TREE = 'km_mod_signals_signal_tree',
  SIGNALS_REPORTS_DATABASE_COMPARE = 'km_mod_signals_database_compare',
  SIGNALS_SCHEDULER = 'km_mod_signals_scheduler',
  SIGNALS_SCHEDULER_CREATE = 'km_mod_signals_scheduler_new_task',
  SIGNALS_SCHEDULER_EDIT = 'km_mod_signals_scheduler_task_edit',
  SIGNALS_SETTINGS = 'km_mod_signals_signal_settings',
  SIGNALS_SYSTEM_REPORTS = 'km_mod_signals_system_reports',
  SIGNALS_SYSTEM_REPORTS_DEVICE_COMMUNICATION = 'km_mod_signals_system_reports_device_comm',
  SIGNALS_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_signals_system_reports_historical',
  SIGNAL_REPORT_MULTI_DATABASE = 'km_mod_signals_system_reports_multi_database_export',
  SIGNS = 'km_modules_signs_overview',
  SIGNS_ALARMS = 'km_mod_signs_manage_alarms',
  SIGNS_ACTIVITY_LOG = 'km_mod_signs_reports_activity_log',
  SIGNS_GROUPS = 'km_mod_signs_manage_groups',
  SIGNS_GROUPS_CREATE = 'km_mod_signs_manage_groups_new',
  SIGNS_GROUPS_EDIT = 'km_mod_signs_manage_groups_edit',
  SIGNS_MANAGE_SIGNS = 'km_modules_signs_manage_signs',
  SIGNS_MESSAGE_PREFERENCES = 'km_mod_signs_config_msg_preferences',
  SPEED_SETTINGS_CREATE = 'km_mod_signs_config_speedsettings_create',
  SPEED_SETTINGS_DELETE = 'km_mod_signs_config_speedsettings_delete',
  SPEED_SETTINGS_EDIT = 'km_mod_signs_config_speedsettings_edit',
  SYSTEM_ACTIVITY_LOG = 'settingsanddocs_security_activity_log',
  SYSTEM_CONFIGURATIONS = 'settingsanddocs_sys_settings_sys_config',
  SYSTEM_CONFIGURATIONS_AUTH = 'settingsanddocs_sys_settings_sys_config_central_auth',
  SYSTEM_CONFIGURATIONS_DATA_RETENTION = 'settingsanddocs_sys_settings_sys_data_retention',
  SYSTEM_CONFIGURATIONS_GENERAL = 'settingsanddocs_sys_settings_config_general',

  SYSTEM_MAP_SETTINGS_ACCESS_TOKEN = 'settingsanddocs_map_settings_AccessToken',
  SYSTEM_MAP_SETTINGS_SIGNALS = 'settingsanddocs_map_settings_SignalsMapSettings',
  TRAVELTIME_ALARMS = 'km_modules_traveltime_maintenance_manage_alarms',
  TRAVELTIME_ACTIVITY_LOG = 'km_modules_traveltime_ActivityLog',
  TRAVELTIME_CREATE_TS_SEGMENT = 'km_modules_traveltime_createTSsegment',
  TRAVELTIME_TRAVEL_TIME_MESSAGES = 'km_modules_traveltime_TravelTimeMessages',
  TRAVELTIME_TRAVELTIMES = 'km_modules_traveltime_traveltimes',
  TRAVELTIME_VIEW_TS_SEGMENT = 'km_modules_traveltime_viewTSsegment',
  TRAVELTIME_SEGMENT_GRAPH_TAB = 'km_modules_traveltime_view_travel_time_segment_graph_tab',
  TRAVELTIME_SEGMENT_HISTORY_TAB = 'km_modules_traveltime_view_travel_time_segment_history_tab',
  TRAVELTIME_SEGMENT_ACTIVITY_TAB = 'km_modules_traveltime_view_travel_time_segment_activity_tab',
  TRAVELTIME_SETTINGS_ALARMS = 'km_modules_traveltime_config_settings_alarm_configuration',
  TRAVELTIME_SETTINGS_THRESHOLDS = 'km_modules_traveltime_config_settings_travel_time_threshold',
  TRAVELTIME_SYSTEM_REPORTS = '',
  TRAVELTIME_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_modules_traveltime_reports_system_reports_historical_alarm_report',
  TUNNELS = 'km_modules_tunnels_managetunnels',
  TUNNEL_LIST = 'km_mod_tunnels_manage',
  TUNNEL_CREATE = 'km_mod_tunnels_create',
  TUNNEL_DETAILS_TAB = 'km_mod_tunnels_edit_details_tab',
  TUNNEL_DEVICES_TAB = 'km_mod_tunnels_edit_devices_tab',
  TUNNEL_SCHEMATIC_TAB = 'km_mod_tunnels_edit_schematics_tab',
  TUNNEL_RULES_TAB = 'km_mod_tunnels_edit_rules_tab',

  TUNNEL_VIEW = 'km_mod_tunnels_view_manage',
  TUNNELS_SETTINGS_ALARM_CONFIGURATION = 'km_mod_tunnels_settings_alarm_configuration',
  TUNNELS_ALARMS = 'km_mod_tunnels_manage_alarms',
  TUNNELS_SYSTEM_REPORTS = '',
  TUNNELS_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_tunnels_reports_system_reports_historical_alarm_report',
  USER_GROUPS = 'settingsanddocs_security_usergroups',
  USERS = 'settingsanddocs_security_users',
  VIDEO_ACTIVITY_LOGS = 'km_modules_video_activitylog',
  VIDEO_ALARMS = 'km_modules_video_manage_alarms',
  VIDEO_CAMERA_GROUPS = 'km_modules_video_config_cameragroups',
  VIDEO_CAMERAS = 'km_modules_video_cameras',

  VIDEO_CAMERA_DETAILS = 'km_modules_video_cameras_manage',
  VIDEO_CAMERA_DETAILS_CONTROL = 'km_modules_video_cameras_manage_control_tab',
  VIDEO_CAMERA_DETAILS_ACTIVITY_LOG = 'km_modules_video_cameras_manage_activity_log_tab',
  VIDEO_CAMERA_DETAILS_SCHEDULE = 'km_modules_video_cameras_manage_schedule_tab',
  VIDEO_CAMERA_DETAILS_WORK_ORDERS = 'km_modules_video_cameras_manage_work_orders_tab',

  VIDEO_RECORDINGS = 'km_modules_video_recordings',
  VIDEO_SCREENS = 'km_modules_video_config_screens',
  VIDEO_SETTINGS = 'km_modules_video_config_settings',
  VIDEO_SETTINGS_WIDGET = 'km_modules_video_config_settings_widget',

  VIDEO_SETTINGS_RECORDING = 'km_modules_video_config_settings_recording',
  VIDEO_SETTINGS_ACTIVITY_LOGS = 'km_modules_video_config_settings_activity_logs',
  VIDEO_SETTINGS_ALARMS = 'km_modules_video_config_settings_alarm_configuration',

  VIDEO_SNAPSHOTS = 'km_modules_video_snapshots',
  VIDEO_TOURS = 'km_modules_video_config_tours',
  VIDEO_WALL = 'km_modules_video_videowall',
  VIDEO_SYSTEM_REPORTS = '',
  VIDEO_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_modules_video_reports_system_reports_historical_alarm_report',
  WEATHER_ACTIVITY_LOGS = 'km_modules_weather_ActivityLogs',

  CONNECTED_VEHICLES_LIST = 'km_mod_connected_veh_manage',
  LOCATIONS_ADD_LANES = '',
  LOCATIONS_ADD_MANEUVERS = '',
  LOCATIONS_ADD_CROSSWALKS = '',
  WEATHER_STATIONS = 'km_modules_weather_weatherstations_overview',
  WEATHER_STATIONS_VIEW = 'km_modules_weather_weatherstations_view',

  WEATHER_STATIONS_VIEW_ACTIVITY_LOGS = 'km_modules_weather_weather_statn_view_activity_log_tab',
  WEATHER_STATIONS_VIEW_WORK_ORDERS = 'km_modules_weather_weather_statn_view_work_order_tab',
  WEATHER_STATIONS_VIEW_REALTIME = 'km_modules_weather_weather_statn_view_real_time_tab',
  WEATHER_STATIONS_VIEW_ATMOSPHERIC = 'km_modules_weather_weather_statn_view_atmospheric_tab',
  WEATHER_STATIONS_VIEW_PAVEMENT = 'km_modules_weather_weather_statn_view_pavement_tab',
  WEATHER_STATIONS_VIEW_SUBSURFACE = 'km_modules_weather_weather_statn_view_subsurface_tab',
  WEATHER_STATIONS_VIEW_GRAPHS = 'km_modules_weather_weather_statn_view_graphs_tab',

  WORKSPACES = 'km_workspaces_overview',

  CONNECTED_VEHICLES_OVERVIEW = 'km_mod_connected_veh_overview',
  CONNECTED_VEHICLES_MANAGE = 'km_mod_connected_veh_manage',
  CONNECTED_VEHICLES_ADD = 'km_mod_connected_veh_add',
  CONNECTED_VEHICLES_EDIT = 'km_mod_connected_veh_edit',

  CONNECTED_VEHICLES_VIEW = 'km_mod_connected_veh_view',
  CONNECTED_VEHICLES_DOCUMENTS = 'km_mod_connected_veh_documents',
  CONNECTED_VEHICLES_ACTIVITY_LOG = 'km_mod_connected_veh_activitylog',
  CONNECTED_VEHICLES_MANAGE_ACTIVITY_LOG = 'km_mod_connected_veh_manage_cv_activitylog',
  CONNECTED_VEHICLES_ALARMS = 'km_mod_connected_veh_alarms',
  CONNECTED_VEHICLES_SETTINGS_ALARMS = 'km_mod_connected_veh_settings_alarms',
  GATES_GATE_SYSTEMS_OVERVIEW = 'km_mod_gates_gate_systems_overview',

  GATES_GATE_SYSTEMS_CREATING_DETAIL_TAB = 'km_mod_gates_gate_systems_creating_detail_tab',
  GATES_GATE_SYSTEMS_CREATING_INBOUND_TAB = 'km_mod_gates_gate_systems_creating_inbound_tab',
  GATES_GATE_SYSTEMS_CREATING_OUTBOUND_TAB = 'km_mod_gates_gate_systems_creating_outbound_tab',
  GATES_GATE_SYSTEMS_CREATING_OPERATIONS_TAB = 'km_mod_gates_gate_systems_creating_operations_tab',
  GATES_GATE_SYSTEMS_CREATING_SCHEMATIC_TAB = 'km_mod_gates_gate_systems_creating_schematic_tab',
  GATES_GATE_SYSTEMS_CREATING = 'km_mod_gates_gate_systems_new',
  GATES_GATE_SYSTEMS_EDITING = 'km_mod_gates_gate_systems_editing',
  GATES_GATE_SYSTEMS_VIEWING = 'km_mod_gates_gate_systems_viewing',
  GATES_GATE_SYSTEMS_DELETING = 'km_mod_gates_gate_systems_deleting',
  GATES_GATE_SYSTEMS_CONFIG = 'km_mod_gates_gate_systems_new_configuration_tab',
  GATES_GATE_SYSTEMS_DEVICES = 'km_mod_gates_gate_systems_new_devices_tab',
  GATES_GATE_SYSTEMS_GROUPS = 'km_mod_gates_gate_systems_new_groups_tab',
  GATES_GATE_SYSTEMS_OPERATIONS = 'km_mod_gates_gate_systems_new_operations_tab',
  GATES_GATE_SYSTEMS_SCHEMATIC = 'km_mod_gates_gate_systems_new_schematic_tab',
  GATES_GATE_SYSTEMS_VIEW_CONTROLLERS = 'km_mod_gates_gate_systems_viewing_controllers_tab',
  GATES_GATE_SYSTEMS_VIEW_OPERATIONS = 'km_mod_gates_gate_systems_managing_operations_tab',
  GATES_GATE_SYSTEMS_VIEW_OPERATION_HISTORY = 'km_mod_gates_gate_systems_viewing_operation_history_tab',
  GATES_GATE_SYSTEMS_VIEW_ACTIVITY_LOG = 'km_mod_gates_gate_systems_viewing_activity_tab',
  GATES_GATE_CONTROLLERS_OVERVIEW = 'km_mod_gates_gate_controllers_overview',
  GATES_GATE_CONTROLLERS_MANAGING = 'km_mod_gates_gate_controllers_managing',
  GATES_GATE_CONTROLLERS_DEVICES_TAB = 'km_mod_gates_gate_controller_viewing_devices_tab',
  GATES_GATE_CONTROLLER_ARMS_TAB = 'km_mod_gates_gate_controller_viewing_arms_tab',
  GATES_GATE_CONTROLLER_STATUS_LOGS_TAB = 'km_mod_gates_gate_controller_viewing_status_logs_tab',
  GATES_GATE_CONTROLLER_VIEWING_WORK_ORDERS_TAB = 'km_mod_gates_gate_controller_viewing_work_orders_tab',
  GATES_MESSAGES = 'km_mod_gates_signs_messages',
  GATES_MESSAGES_CREATE = 'km_mod_gates_signs_messages_create',
  GATES_MESSAGES_EDIT = 'km_mod_gates_sign_messages_edit',
  GATES_MESSAGES_CLONE = 'km_mod_gates_signs_messages_clone',
  GATE_SETTINGS = 'km_mod_gates_config_settings',
  GATE_ALARMS = 'km_mod_gates_maintenance_manage_alarms',
  GATES_ACTIVITY_LOG = 'km_mod_gates_resports_activitylog',
  GATES_SYSTEM_REPORTS = '',
  GATES_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_gates_reports_system_reports_historical_alarm_report',
  GATES_SETTINGS_STATUS_LOG = 'km_mod_gates_config_settings_status_log',
  GATES_SETTINGS_STATE = 'km_mod_gates_config_settings_gate_state',
  GATES_SETTINGS_STATE_ALARMS = 'km_mod_gates_config_settings_alarm_configuration',
  SIGNALS_SIGNAL_TRAFFIC_RESPONSIVE_EDIT = 'km_mod_signals_signal_TRplan_edit',
  SIGNALS_SIGNAL_TRAFFIC_RESPONSIVE_VIEW = 'km_mod_signals_signal_TRplan_view',
  COUNTS_SITE_DETAIL_DEVICE_ACTIVITY = 'km_mod_counts_sitesdetail_device_activity',
  COUNTS_SITE_DETAIL_LANES = 'km_mod_counts_sitesdetail_lanes',
  COUNTS_SITE_DETAIL_WORK_ORDERS = 'km_mod_counts_sitesdetail_work_order',
  SYSTEM_SETTINGS_EMAIL_SERVER_SETTINGS = 'settingsanddocs_sys_settings_sys_emailserver_settings',
  SYSTEM_SETTINGS_NOTIFICATIONS = 'settingsanddocs_sys_settings_sys_config_notifications',
  RAMP_METER_LIST = 'km_mod_ramp_meter_manage',
  RAMP_METER_DOCUMENTS = 'km_mod_ramp_meter_view_documents_tab',
  RAMP_METER_CREATE = 'km_mod_ramp_meter_add',
  RAMP_METER_EDIT = 'km_mod_ramp_meter_edit',
  RAMP_METER_DELETE = 'km_mod_ramp_meter_delete',
  RAMP_METER_CONFIGURATION_OVERVIEW = 'km_mod_ramp_meter_view_overview_tab',
  RAMP_METER_CONFIGURATION_DETAILS = 'km_mod_ramp_meter_add_details_tab',
  RAMP_METER_CONFIGURATION_DETECTORS = 'km_mod_ramp_meter_add_detectors_tab',
  RAMP_METER_CONFIGURATION_MAP_DETAILS = 'km_mod_ramp_meter_add_mapdetails',
  SIGNALS_UTDF_IMPORT_EXPORT_TOOL = '',
  RAMP_METER_DETAILS_VIEW = 'km_mod_ramp_meter_view',
  RAMP_METER_DETAIL_ACTIVITY_LOG = 'km_mod_ramp_meter_view_activity_log_tab',
  RAMP_METER_DETAIL_DATABASES = 'km_mod_ramp_meter_view_databases_tab',
  RAMP_METER_DETAIL_SCHEDULER = 'km_mod_ramp_meter_view_scheduler_tab',
  RAMP_METER_SCHEDULER = 'km_mod_ramp_meter_scheduler',
  RAMP_METER_SCHEDULER_EDIT = 'km_mod_ramp_meter_scheduler_task_edit',
  RAMP_METER_SCHEDULER_CREATE = 'km_mod_ramp_meter_scheduler_new_task',
  SIGNALS_SETTINGS_COMMAND_LIMITS = 'settingsanddocs_sys_settings_sys_signals_rampmeter_settings',
  SIGNALS_SETTINGS_DATABASE_EDITOR = 'settingsanddocs_sys_settings_sys_signals_rampmeter_settings',
  SIGNALS_SETTINGS_TIME_DRIFT = 'settingsanddocs_sys_settings_sys_signals_rampmeter_settings',
  RAMP_METER_DATABASE_EDITOR_STATUS = 'km_mod_ramp_meter_dbeditor_config_edit_database',
  RAMP_METER_DATABASE_EDITOR_CONFIGURATION = 'km_mod_ramp_meter_dbeditor_config_view_controller_status',
  RAMP_METER_APPLIED_COMMANDS = 'km_mod_ramp_meter_applied_commands',
  RAMP_METER_ACTIVITY_LOG = 'km_mod_ramp_meter_activitylog',
  ROAD_CONDITIONS_LIST = 'km_mod_road_conditions_overview',
  ROAD_CONDITIONS_EVENT_CREATE = 'km_mod_road_conditions_create',
  TOLLING_ACTIVITY_LOG = 'km_mod_tolling_reports_activitylog',
  TOLL_POINTS_LIST = 'km_mod_tolling_manage_toll_points',
  TOLLING_ALARMS = 'km_mod_tolling_maintenance_manage_alarms',
  TOLLING_SYSTEM_REPORTS = '',
  TOLLING_SYSTEM_REPORTS_HISTORICAL_ALARMS = 'km_mod_tolling_reports_system_reports_historical_alarm_report',
  TOLLING_POINT_DETAIL_ACTIVITY_LOG = 'km_mod_tolling_manage_toll_points_activity_log_tab',
  TOLLING_POINT_DETAIL_DOCUMENTS = 'km_mod_tolling_manage_toll_points_documents_tab',
  TOLLING_SIGN_MESSAGES = 'km_mod_tolling_config_tolling_sign_messages',
  TOLLING_SIGN_MESSAGE_CREATE = 'km_mod_tolling_config_tolling_sign_messages_new',
  TOLLING_SETTINGS_ALARMS = 'km_mod_tolling_settings_alarm_configuration',
  TOLLING_SETTINGS_GENERAL = 'km_mod_tolling_settings_configuration',
  TRANSIT_ROUTES_LIST = 'km_mod_transit_routes_list',
  TRANSIT_ROUTE_DETAILS_VIEW = 'km_mod_transit_route_view',
  MIB_ALARM_CREATE = '',
  MIB_ALARM_EDIT = '',
  TOLLING_SEGMENTS_LIST = 'km_mod_tolling_manage_toll_segments',
  TOLLING_SEGMENT_CREATE = 'km_mod_tolling_manage_toll_segments_add_segment',
  TOLLING_SEGMENT_EDIT = 'km_mod_tolling_manage_toll_segments_edit_segment_config',
  TOLLING_SEGMENT_DETAIL_SIGNS = 'km_mod_tolling_manage_toll_segments_manage_signs_tab',
  TOLLING_SEGMENT_DETAIL_DETECTORS = 'km_mod_tolling_manage_toll_segments_manage_counts_tab',
  TOLLING_SEGMENT_DETAIL_DOCUMENTS = 'km_mod_tolling_manage_toll_segments_manage_documents_tab',
  TOLLING_SEGMENT_DETAIL_ACTIVITY_LOG = 'km_mod_tolling_manage_toll_segments_manage_activity_log_tab',
  TOLLING_SEGMENT_DETAIL_COMMENTS = 'km_mod_tolling_manage_toll_segments_manage_comments_tab',
  TOLLING_SEGMENT_DETAIL_SIGN_HISTORICAL_PRICING = '',
  TOLLING_ROAD_LIST = 'km_mod_tolling_manage_toll_roads',
  TOLLING_ROAD_CREATE = 'km_mod_tolling_manage_toll_roads_new',
  TOLLING_ROAD_EDIT = 'km_mod_tolling_manage_toll_roads_edit',
  TOLLING_PRICING_LIST = 'km_mod_tolling_pricing',
  TOLLING_POINT_DETAIL_GROUPS = '',

  TOLLING_PRICING_DETAILS_RATES = 'km_mod_tolling_pricing_rates',
  TOLLING_PRICING_DETAILS_HISTORY = 'km_mod_tolling_pricing_history',
  TOLLING_PRICING_DETAILS_ACTIVITY_LOG = 'km_mod_tolling_pricing_activity',

  FLEET_DRIVERS_LIST = 'km_mod_fleet_drivers',
  FLEET_DRIVERS_CREATE = 'km_mod_fleet_drivers_new',
  FLEET_DRIVERS_EDIT = 'km_mod_fleet_drivers_edit',
  FLEET_DRIVERS_ACTIVITY_LOG = 'km_mod_fleet_drivers_activity_log',

  FLEET_VEHICLES_LIST = 'km_mod_fleet_vehicles',
  FLEET_VEHICLES_CREATE = 'km_mod_fleet_vehicles_new',
  FLEET_VEHICLES_EDIT = 'km_mod_fleet_vehicles_edit',

  ROAD_ASSISTANCE_SHIFTS_LIST = 'km_mod_road_assistance_shifts',
  ROAD_ASSISTANCE_SHIFTS_VIEW = 'km_mod_road_assistance_shifts_driver_details',

  ROAD_ASSISTANCE_ROUTES_LIST = 'km_mod_road_assistance_routes',
  ROAD_ASSISTANCE_ROUTES_CREATE = 'km_mod_road_assistance_routes_create',
  ROAD_ASSISTANCE_ROUTES_EDIT = 'km_mod_road_assistance_routes_edit',
}
